const POSITION = 'bottom-center';

export function success (instance, messages)
{
	instance.$toasted.show(
		messages.join('<br/>'),
		{
			position: POSITION,
			type: 'success',
			fullWidth: true,
			duration: 3000
		}
	);
}

export function error (instance, messages)
{
	instance.$toasted.show(
		messages.join('<br/>'),
		{
			position: POSITION,
			type: 'error',
			fullWidth: true,
			duration: 5000
		}
	);
}